import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import StaffDeployment from './components/StaffDeployment';
import WhyChoose from './components/WhyChoose';
import Mission from './components/Mission';
import Trusted from './components/Trusted';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <Services />
      <StaffDeployment />
      <WhyChoose />
      <Mission />
      <Trusted />
      <Contact />
      <Footer />
    </div>
  );
}
